// CodeTextarea.js - Isolated Code Editor Component
import React, { useRef, forwardRef, useImperativeHandle } from 'react'

const CodeTextarea = forwardRef((props, ref) => {
  const {
    value,
    onChange,
    placeholder,
    className,
    disabled,
    isLoading,
    isStreaming,
  } = props

  const textareaRef = useRef(null)

  // Expose ref to parent
  useImperativeHandle(ref, () => ({
    focus: () => {
      if (textareaRef.current && !textareaRef.current.disabled) {
        textareaRef.current.focus()
      }
    },
    blur: () => {
      if (textareaRef.current) {
        textareaRef.current.blur()
      }
    },
    get current() {
      return textareaRef.current
    },
    get disabled() {
      return textareaRef.current?.disabled || false
    },
    get scrollTop() {
      return textareaRef.current?.scrollTop || 0
    },
    set scrollTop(value) {
      if (textareaRef.current) {
        textareaRef.current.scrollTop = value
      }
    },
    get scrollHeight() {
      return textareaRef.current?.scrollHeight || 0
    },
  }))

  const handleClick = e => {
    e.stopPropagation()
  }

  const handleFocus = e => {
    e.stopPropagation()
  }

  const handleChange = e => {
    if (onChange) {
      onChange(e)
    }
  }

  return (
    <textarea
      ref={textareaRef}
      className={className}
      value={value}
      onChange={handleChange}
      onClick={handleClick}
      onFocus={handleFocus}
      placeholder={placeholder}
      disabled={disabled}
      style={{
        cursor: isLoading || isStreaming ? 'not-allowed' : 'text',
      }}
    />
  )
})

CodeTextarea.displayName = 'CodeTextarea'

export default CodeTextarea
